// Route parser extracted from monolith
const VALID_VIEWS = [
  'dashboard', 'pipeline', 'sites', 'analytics', 'calendar',
  'email', 'partners', 'activity', 'documents', 'admin', 'chat', 'help', 'guide', 'accounting'
];

export function parseRoute() {
  const p = window.location.pathname;
  const pts = p.split('/').filter(Boolean);

  if (!pts.length || pts[0] === 'dashboard') return { view: 'dashboard' };

  if (pts[0] === 'sites' && pts[1]) {
    const sid = parseInt(pts[1]);
    return { view: 'sites', siteId: sid };
  }

  if (VALID_VIEWS.indexOf(pts[0]) !== -1) return { view: pts[0] };

  return { view: 'dashboard' };
}
